import { permissionTree, RESOURCE_MANTENIMIENTO } from '@/auth/permissions/modules/mantenimientoMaquinariaPg'
import {
    ROUTE_CREAR_ORDEN_TRABAJO,
    ROUTE_GESTION_ORDEN_TRABAJO,
    ROUTE_PARAMETRIZACION_PLANES_MANTENIMIENTO,
} from '@/router/routes/mantenimiento-pg/nombres/transacciones'
import { defineMenu } from '@/utils/menu'

const { transacciones } = permissionTree
export default defineMenu([
    {
        title: 'manprog.subopciones.parametrizacion_planes_mantenimiento',
        action: transacciones.parametrizacionPlanesMantenimiento,
        resource: RESOURCE_MANTENIMIENTO,
        route: ROUTE_PARAMETRIZACION_PLANES_MANTENIMIENTO,
    },
    {
        title: 'manprog.subopciones.gestion_orden_trabajo',
        action: transacciones.gestionOrdenTrabajo,
        resource: RESOURCE_MANTENIMIENTO,
        route: ROUTE_GESTION_ORDEN_TRABAJO,
    },
    {
        title: 'manprog.subopciones.orden_trabajo',
        action: transacciones.crearOrdenTrabajo,
        resource: RESOURCE_MANTENIMIENTO,
        route: ROUTE_CREAR_ORDEN_TRABAJO,
    },
])
